export const formatHour = (hourStr?: string): string | undefined => {
	if (!hourStr) {
		return undefined;
	}
	const hour = parseInt(hourStr, 10);
	const paddedHour = hour.toString().padStart(2, '0');
	return `${paddedHour}:00:00`;
};
